const generateLabel = val => {
  if (val >= 1000000) return Math.round(val / 1000000) + 'M';
  if (val >= 1000) return Math.round(val / 1000) + 'k';
  return Math.round(val / 100) * 100;
}

export default generateLabel;